/**
 * @generated SignedSource<<d6d2b94b64061c3edf9f2670d4954f0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type usePersonsWithApprovableTimeQuery$variables = {
  weekStart: string;
  weekEnd: string;
};
export type usePersonsWithApprovableTimeQuery$data = {
  readonly viewer: {
    readonly id: string;
    readonly company: {
      readonly id: string;
      readonly personsWithApprovableTime: ReadonlyArray<string | null> | null;
    } | null;
  } | null;
};
export type usePersonsWithApprovableTimeQuery = {
  variables: usePersonsWithApprovableTimeQuery$variables;
  response: usePersonsWithApprovableTimeQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weekEnd"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weekStart"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "endDate",
                "variableName": "weekEnd"
              },
              {
                "kind": "Variable",
                "name": "startDate",
                "variableName": "weekStart"
              }
            ],
            "kind": "ScalarField",
            "name": "personsWithApprovableTime",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePersonsWithApprovableTimeQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePersonsWithApprovableTimeQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "7090e94c0ce16f61c904c57ae4e9feca",
    "id": null,
    "metadata": {},
    "name": "usePersonsWithApprovableTimeQuery",
    "operationKind": "query",
    "text": "query usePersonsWithApprovableTimeQuery(\n  $weekStart: String!\n  $weekEnd: String!\n) {\n  viewer {\n    id\n    company {\n      id\n      personsWithApprovableTime(startDate: $weekStart, endDate: $weekEnd)\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eec7aa12ec58c5fdbb8a36793398666a";

export default node;
